import React from 'react';
import { useUserAndGameContext } from '../../../contexts/UserAndGameContext';
import { useGolfLeagueContext } from '../context/GolfLeagueContext';
import { Box, Typography, Container } from '@mui/material';
import TeamCard from './TeamCard';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const TeamPage = () => {
    const {
        teams,
        events,
        intervalsToShow,
        findTournamentId,
        findTournamentInfo,
    } = useGolfLeagueContext();

    const {
        masterPoolData,
        masterPoolId,
        gameId,
        gameAddress,
    } = useUserAndGameContext();
    
    //console.log("Interval", interval, "First Interval", firstInterval, "Last Interval", lastInterval);

    const teamsPageInfo = masterPoolData?.pageInfo?.teams;
    const teamsPageTitle = teamsPageInfo?.pageTitle || "The Teams";
    const textColor = teamsPageInfo?.textColor || "#002129";
    
    //console.log("Intervals To Show", intervalsToShow);
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Container 
            maxWidth={false}
            sx={{ 
                px: { xs: 2, md: 3 },
                maxWidth: '1200px'
            }}
        >
            <Typography
                sx={{
                    fontSize: '40px',
                    fontWeight: '800',
                    margin: '24px 0',
                    textAlign: 'center',
                    color: textColor,
                }}
            >
                {teamsPageTitle}
            </Typography>

            {/* Centered flexbox layout with fixed gap */}
            <Box 
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '4px', // Fixed 32px gap between cards
                    mb: 4
                }}
            >
                {teams?.map((team, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: isMobile ? '100%' : 'calc((100% - 32px) / 2)', // Divide remaining space evenly
                            maxWidth: isMobile ? 'none' : '450px', // Limit maximum card width
                            minWidth: isMobile ? 'none' : '300px', // Ensure reasonable minimum width
                            // Special case for last item in an odd-length array
                            ...((!isMobile && teams.length % 2 !== 0 && index === teams.length - 1) && {
                                width: 'calc((100% - 32px) / 2)', // Keep same width as others
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            })
                        }}
                    >
                        <TeamCard
                            team={team}
                            intervalsToShow={intervalsToShow}
                            events={events}
                            masterPoolId={masterPoolId}
                            gameId={gameId}
                            gameAddress={gameAddress}
                            findTournamentId={findTournamentId}
                            findTournamentInfo={findTournamentInfo}
                        />
                    </Box>
                ))}
            </Box>
        </Container>
    );
}

export default TeamPage;